var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UserSearchDialog',{attrs:{"value":_vm.value,"search-action":_vm.searchAction},on:{"input":_vm.hideDialog,"user-selected":_vm.emitUserSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }